import { render, staticRenderFns } from "./ContactInside.vue?vue&type=template&id=58684c86&scoped=true&"
import script from "./ContactInside.vue?vue&type=script&lang=js&"
export * from "./ContactInside.vue?vue&type=script&lang=js&"
import style0 from "./ContactInside.vue?vue&type=style&index=0&id=58684c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58684c86",
  null
  
)

export default component.exports